"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureTransaction = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const aui_popover_1 = require("../aui-popover");
const bottom_sheet_1 = require("../bottom-sheet");
const page_wrapper_1 = require("../page-wrapper");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const SecureTransaction = (props) => {
    const deviceView = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    switch (deviceView) {
        case monera_app_core_1.DeviceType.MShop:
        case monera_app_core_1.DeviceType.Mobile:
            return react_1.default.createElement(SecureTransactionMobile, Object.assign({}, props));
        case monera_app_core_1.DeviceType.Desktop:
        case monera_app_core_1.DeviceType.Tablet:
        default:
            return react_1.default.createElement(SecureTransactionDesktop, Object.assign({}, props));
    }
};
exports.SecureTransaction = SecureTransaction;
const addPrefix = (suffix) => {
    return `secure-transaction-${suffix}`;
};
const SecureTransactionCommon = (props) => {
    const { secureTransactionCopy, onClick, id } = props;
    return (react_1.default.createElement(styles_1.SecureTransactionContainer, { "data-cy": addPrefix('container') },
        react_1.default.createElement("svg", { "aria-hidden": "true", width: "12", height: "15", viewBox: "0 0 12 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("rect", { y: "5", width: "12", height: "10", rx: "2", fill: "#999999" }),
            react_1.default.createElement("path", { d: "M8.75 3.92857C8.75 5.59033 7.47545 6.85714 6 6.85714C4.52455 6.85714 3.25 5.59033 3.25 3.92857C3.25 2.26682 4.52455 1 6 1C7.47545 1 8.75 2.26682 8.75 3.92857Z", stroke: "#999999", strokeWidth: "2" })),
        react_1.default.createElement(styles_1.SecureTransactionAnchor, { role: 'button', href: 'javascript:void(0)', id: id, "data-cy": addPrefix('text'), onClick: onClick }, secureTransactionCopy),
        props.children));
};
const SecureTransactionDesktop = (props) => {
    const { secureTransactionCopy, descriptionCopy, linkHref, linkCopy, headingCopy, learnMoreAboutSecureTransaction } = props;
    const inlineContent = `${descriptionCopy} <a href="${linkHref}" target="_blank" rel="noreferrer" aria-label="${learnMoreAboutSecureTransaction}">${linkCopy}</a>`;
    const componentId = 'secure-transaction';
    return (react_1.default.createElement(SecureTransactionCommon, { id: componentId, secureTransactionCopy: secureTransactionCopy },
        react_1.default.createElement(aui_popover_1.AuiPopover, { triggerComponentId: componentId, activate: 'onmouseover', header: headingCopy, inlineContent: inlineContent, position: 'triggerBottom' })));
};
const SecureTransactionMobile = (props) => {
    const { secureTransactionCopy, descriptionCopy, linkHref, linkCopy, headingCopy, learnMoreAboutSecureTransaction } = props;
    const [isPopupOpen, setIsPopupOpen] = (0, react_1.useState)(false);
    const openPopup = () => {
        setIsPopupOpen(true);
    };
    const closePopup = () => {
        setIsPopupOpen(false);
    };
    return (react_1.default.createElement(SecureTransactionCommon, { secureTransactionCopy: secureTransactionCopy, onClick: openPopup },
        react_1.default.createElement(bottom_sheet_1.BottomSheet, { isOpen: isPopupOpen, headerText: headingCopy, onClose: closePopup },
            react_1.default.createElement(themed_text_1.ThemedSpan, null,
                descriptionCopy,
                ' ',
                react_1.default.createElement("a", { href: linkHref, target: '_blank', rel: 'noreferrer', "aria-label": learnMoreAboutSecureTransaction }, linkCopy)))));
};
__exportStar(require("./types"), exports);
